export default __webpack_public_path__ + "static/media/change-card.bc9056be.png";